import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { useForm } from '@inertiajs/vue3';
    import CompanyGroupForm from '@/components/company-groups/CompanyGroupForm.vue';
    import DialogForm from '@/components/DialogForm.vue';
    import QueryKey from '@/enums/QueryKey';

    
export default /*@__PURE__*/_defineComponent({
  __name: 'CreateCompanyGroup',
  setup(__props) {

    const form = useForm({
        name: '',
        companyIds: [],
    });

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(DialogForm, {
    type: "create",
    form: _unref(form),
    route: _ctx.route('v2.company-groups.store'),
    "query-key": [_unref(QueryKey).COMPANY_GROUPS],
    title: "company-groups.company_groups_create",
    "success-message": "company-groups.created",
    "button-text": "company-groups.company_groups_create"
  }, {
    default: _withCtx(() => [
      _createVNode(CompanyGroupForm, { form: _unref(form) }, null, 8, ["form"])
    ]),
    _: 1
  }, 8, ["form", "route", "query-key"]))
}
}

})